export const PAGES = {
  GaragePurchased: 'my-vehicles',
  GarageFavorites: 'my-favorites',
  VehicleDetails: (id) => `vehicle/${id}`,
  Inventory: 'inventory',
  RacommendAFriend: 'recommendfriend',
  Referrals: 'referrals',
  ReferralHowItWorks: 'how-it-works',
  Refer: 'refer',
  DeletedDealer: 'deleted/dealer',
  DeletedSalesperson: 'deleted/salesperson',
  Reassigned: 'reassigned',
  TermAndConditions: 'terms',
  PrivacyPolicy: 'policy'
}



// WEBPACK FOOTER //
// ./scripts/src/shared/routes.constants.js